  export const isUserAvailable = (user): any => {
    if (user == null) return false;
  
    if (typeof user === 'object' && Object.keys(user).length > 0) {
      return true;
    }
  
    return false;
  };